import React from 'react';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { MULTI_FILE_UPLOAD_LIMIT_MAX, MULTI_FILE_UPLOAD_LIMIT_MIN } from '@cs-cms/types';
import { ConfigurationLimitStatus } from './ConfigurationLimitStatus';
import { useMultiFileUploadLimitConfig } from './useMultiFileUploadLimitConfig';

export const MultiFileUploadLimitConfig: React.FC = () => {
  const {
    translate,
    DialogComponent,
    indexOptions,
    selectedOption,
    displayLimit,
    isLimitInputDisabled,
    limitStatusProps,
    isSaveDisabled,
    saveButtonLabel,
    handleIndexChange,
    handleLimitChange,
    handleSave
  } = useMultiFileUploadLimitConfig();

  const {
    isLoading,
    isLoadingPermissions,
    error,
    canEdit,
    selectedIndex,
    currentLimit,
    hasUnsavedChanges
  } = limitStatusProps;

  return (
    <>
      <div className="configurationsCard">
        <div className="configurationsCardHeader">
          <h3 className="configurationsCardTitle">
            {translate('custom.settings.adminCenter.configurations.multiFileUploadLimit.title')}
          </h3>
          <p className="configurationsCardDescription">
            {translate('custom.settings.adminCenter.configurations.multiFileUploadLimit.description')}
          </p>
        </div>

        <div className="configurationsCardContent">
          <div className="configurationsFormRow">
            <div className="configurationsFormField">
              <label className="configurationsLabel">
                {translate('custom.settings.adminCenter.configurations.index.label')}
              </label>
              <DropDownList
                data={indexOptions}
                textField="text"
                dataItemKey="value"
                value={selectedOption}
                onChange={handleIndexChange}
              />
            </div>

            <div className="configurationsFormField">
              <label className="configurationsLabel">
                {translate('custom.settings.adminCenter.configurations.limit.label')}
              </label>
              <NumericTextBox
                value={displayLimit}
                onChange={handleLimitChange}
                min={MULTI_FILE_UPLOAD_LIMIT_MIN}
                max={MULTI_FILE_UPLOAD_LIMIT_MAX}
                placeholder={translate('custom.settings.adminCenter.configurations.limit.placeholder')}
                disabled={isLimitInputDisabled}
              />
            </div>
          </div>

          <ConfigurationLimitStatus
            isLoading={isLoading}
            isLoadingPermissions={isLoadingPermissions}
            error={error}
            canEdit={canEdit}
            selectedIndex={selectedIndex}
            currentLimit={currentLimit}
            hasUnsavedChanges={hasUnsavedChanges}
            translate={translate}
          />
        </div>

        <div className="configurationsCardActions">
          <Button
            type="button"
            themeColor="primary"
            onClick={handleSave}
            className="configurationsSaveButton"
            disabled={isSaveDisabled}
          >
            {saveButtonLabel}
          </Button>
        </div>
      </div>
      {DialogComponent}
    </>
  );
};
